import UserApi from "@/services/UserApi";
import store from "../store";
// import { isObject } from "util";
import { EventBus } from "@/services/EventBus.js";

export default {
  login(params) {
    store.commit("setLoadingUser", true);
    const paramData = Object.entries(params)
      .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
      .join('&');
    return UserApi()
      .post("", paramData)
      .then(function(response) {
        if (
          response.data.error === undefined &&
          response.data.user.id !== undefined &&
          response.data.user.id > 0
        ) {
          store.commit("saveUser", response.data);
          store.commit("unsetQuickErrors", "User Login");
          store.commit("setStepComplete", "Account");
          store.commit("setStepComplete", "Contact");
          EventBus.$emit("userLogin", {} );
          if( params.action == "user_create" )
          {
            EventBus.$emit("userCreated", {} );
          }
          return true;
        } else {
          if (response.data.error === "Not logged in") {
            console.log("TCL: login -> response.data.error", response.data.error);
            store.commit("logoutUser");
            return false;
          }
          store.commit("setErrorState", [
            "User Login",
            response.data.error
          ]);
          return false;
        }
      })
      .catch(function(error) {
        console.log("API Login ERROR: ", error);
        store.commit("setErrorState", [
          "User Login",
          error
        ]);
        return false;
      })
      .finally(function() {
        store.commit("setLoadingUser", false);
      });
  },
  logout(params) {
    store.commit("setLoadingUser", true);
    const paramData = Object.entries(params)
      .map(([key, val]) => {
        if (typeof val == "object") {
          return Object.entries(params)
            .map(([key2, val2]) => `${key2}=${encodeURIComponent(val2)}`).join('&');
        } else {
          return `${key}=${encodeURIComponent(val)}`;
        }
      })
      .join('&');
    return UserApi()
      .post("", paramData)
      .then(function(response) {
        if (response.data.error === undefined) {
          store.commit("logoutUser");
          store.commit("unsetQuickErrors", "User Login");
          console.log("TCL: User logged out of API");
        } else {
          store.commit("setErrorState", [
            "User Login",
            response.data.error
          ]);
        }
      })
      .catch(function(error) {
        console.log("API Logout ERROR: ", error);
        store.commit("setErrorState", [
          "User Login",
          error
        ]);
      })
      .then(function() {
        store.commit("setLoadingUser", false);
      });
  }
};
